import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Users = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'user',
    numbers: '',
    managerId: ''
  });
  const [users, setUsers] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const token = localStorage.getItem('token');

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(res.data);
    } catch (err) {
      console.error('Erro ao carregar usuários:', err);
    }
  };

  useEffect(() => {
    fetchUsers();

    // Garante que o formulário inicie limpo
    setForm({
      name: '',
      email: '',
      password: '',
      role: 'user',
      numbers: '',
      managerId: ''
    });
    setEditingId(null);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        numbers: form.numbers.split(',').map(num => num.trim())
      };

      if (editingId) {
        await axios.put(`${process.env.REACT_APP_API_URL}/users/${editingId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      await fetchUsers();
      setForm({
        name: '',
        email: '',
        password: '',
        role: 'user',
        numbers: '',
        managerId: ''
      });
      setEditingId(null);
    } catch (err) {
      console.error('Erro ao salvar usuário:', err);
    }
  };

  const handleEdit = (user) => {
    setForm({
      name: user.name || '',
      email: user.email || '',
      password: '',
      role: user.role || 'user',
      numbers: user.numbers?.join(', ') || '',
      managerId: user.managerId || ''
    });
    setEditingId(user._id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await fetchUsers();
    } catch (err) {
      console.error('Erro ao deletar usuário:', err);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">User Management</h2>

      <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow mb-6 space-y-4 max-w-xl">
        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
        <input
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
           autoComplete="off"
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
           autoComplete="new-password"  // ajuda ainda mais para senha

        />
        <select
          name="role"
          value={form.role}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        >
          <option value="user">user</option>
          <option value="manager">manager</option>
          <option value="admin">admin</option>
        </select>
        <input
          name="numbers"
          placeholder="Phone numbers (comma-separated)"
          value={form.numbers}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
        <select
          name="managerId"
          value={form.managerId}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        >
          <option value="">⎯</option>
          {users
            .filter(u => u.role === 'manager' || u.role === 'admin')
            .map(u => (
              <option key={u._id} value={u._id}>
                {u.name}
              </option>
            ))}
        </select>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Save
        </button>
      </form>

      <h3 className="text-lg font-semibold mb-2">User List</h3>
      <table className="w-full bg-white rounded shadow text-sm">
        <thead>
          <tr className="bg-gray-200 text-left">
            <th className="p-2">Name</th>
            <th className="p-2">Email</th>
            <th className="p-2">Role</th>
            <th className="p-2">Phones</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u._id} className="border-t">
              <td className="p-2">{u.name}</td>
              <td className="p-2">{u.email}</td>
              <td className="p-2">{u.role}</td>
              <td className="p-2">{u.numbers?.join(', ')}</td>
              <td className="p-2">
                <button onClick={() => handleEdit(u)} className="text-blue-600 mr-2">
                  Edit
                </button>
                <button onClick={() => handleDelete(u._id)} className="text-red-600">
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Users;
